import dayjs from 'dayjs';

export const normalizeChartData = (
  data: { x: string; y: number }[],
): { x: string; y: number }[] => {
  return data.length === 1
    ? [{ x: dayjs(data[0].x).subtract(1, 'day').format('DD-MM-YYYY'), y: 0 }, ...data]
    : data;
};
